export default __webpack_public_path__ + "static/media/Mordec Boots.88a1b2d6.jpg";